import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { Block } from 'shared/components/Block';
import { SubTitle } from 'shared/components/SubTitle';
import { TextInfoWithImage } from 'shared/components/TextInfoWithImage';
import { DESCRIPTION, LIST } from './constants';
import { DetailsBtnLink } from 'shared/components/DetailsBtnLink';
import { SMART_DEAL } from 'shared/constants/links';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const SmartDeal: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.SmartDeal}>
          <Block>
            <SubTitle text="SmartDeal" />
            <TextInfoWithImage description={DESCRIPTION} list={LIST} image="smart-deal" />
            <DetailsBtnLink link={SMART_DEAL} withOutMargin />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
